import { BASIC_COURSE_SOURCE_ALIASES } from "./basicCourseSourceAliases";
import { getBasicCourseGroupSources } from "./basicCourseMetadata";

export { BASIC_COURSE_SOURCE_ALIASES } from "./basicCourseSourceAliases";

export function getVerifiedBasicCourseSources(type) {
  return getBasicCourseGroupSources(BASIC_COURSE_SOURCE_ALIASES[type] || type)
    .filter(source => source.sheetId.startsWith("cke-p-"));
}

export const isBasicCourseTaskType = type => getVerifiedBasicCourseSources(type).length > 0;

export function isBasicCourseTask(task) {
  if (!isBasicCourseTaskType(task?.type)) return false;
  const sheetId = task.basicCourseSource?.sheetId || task.source?.sheetId;
  if (sheetId && !sheetId.startsWith("cke-p-")) return false;
  return !/MMAP-R/i.test(task.source?.basedOn || "") && task.source?.level !== "extended";
}
